import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "layout"
};
const _hoisted_2 = {
  class: "navbar-title"
};
const _hoisted_3 = {
  key: 1
};
import { useStore } from "@/store/index";
import { storeToRefs } from 'pinia';
import { usebaseRouter } from "@/utils/hooks";

import { showConfirmDialog } from 'vant/es';
import 'vant/es/dialog/style/index';
export default {
  __name: 'index',
  props: {
    title: {
      type: String,
      default: ''
    },
    isShowBack: {
      type: Boolean,
      default: true
    },
    isBg: {
      type: Boolean,
      default: false
    },
    isShowRightIcon: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const {
      navigate
    } = usebaseRouter();
    const store = useStore();
    const {
      token
    } = storeToRefs(store);
    const toLogin = () => {
      showConfirmDialog({
        title: '提示',
        message: '请先登录',
        confirmButtonText: '去登录'
      }).then(() => {
        let url = location.origin + '/#/login';
        location.replace(url);
      });
    };
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["navbar", {
          bg: __props.isBg
        }])
      }, [__props.isShowBack ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "navbar-back",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.back())
      }, [_createVNode(_component_van_icon, {
        name: "arrow-left",
        size: "20"
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1), __props.isShowRightIcon ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_unref(token) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "navbar-rightIcon",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push('mine'))
      }, "个人中心")) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "toLogin",
        onClick: toLogin
      }, "登录"))])) : _createCommentVNode("", true)], 2)]);
    };
  }
};